<cdk-virtual-scroll-viewport
  [itemSize]="lineHeight"
  [style.height.px]="listHeight"
  *ngIf="lineMap?.size; else noResult">
  <table md-table class="fixed-layout md-table" *ngIf="permissionsBS.value">
    <thead class="md-head">
      <tr>
        <th md-column class="align-center md-column">&nbsp;</th>
        <th md-column class="align-center md-column" *ngFor="let permission of permissionsColumns">
          {{ permission.label | translate }}
          <mat-icon class="tooltip-qmark-role-edition" [matTooltip]="permissionsTooltips[permission.id]"
            >help_outline
          </mat-icon>
        </th>
      </tr>
      <tr>
        <th md-column class="align-center md-column">&nbsp;</th>
        <th md-column class="align-center md-column" *ngFor="let permission of permissionsColumns">
          <mat-checkbox
            *ngIf="!readonly"
            [checked]="columnMap.get(permission.id).size === items.length"
            [indeterminate]="
              (columnMap.get(permission.id)?.size || 0) > 0 && columnMap.get(permission.id).size !== items.length
            "
            (change)="permissionColumnChange.emit(permission)">
          </mat-checkbox>
        </th>
      </tr>
    </thead>
    <tbody class="md-body">
      <tr *cdkVirtualFor="let item of $any(items)" class="md-row">
        <td class="md-cell">
          <div class="site-header-line">
            <app-site-icon-and-name [item]="item">
              <a [href]="item.href" target="_blank">{{ item.label }}</a>
            </app-site-icon-and-name>
            <mat-checkbox
              *ngIf="!readonly && (!disabledMap || disabledMap.get(item.id)?.size !== permissionsColumns.length)"
              [checked]="lineMap.get(item.id).size === permissionsColumns.length"
              [indeterminate]="
                (lineMap.get(item.id)?.size || 0) > 0 && lineMap.get(item.id).size !== permissionsColumns.length
              "
              (change)="permissionLineChange.emit(item.id)">
            </mat-checkbox>
          </div>
        </td>
        <td class="md-cell align-center" *ngFor="let permission of permissionsColumns">
          <mat-checkbox
            [checked]="lineMap.get(item.id).has(permission.id) || disabledMap?.get(item.id)?.has(permission.id)"
            [disabled]="readonly || disabledMap?.get(item.id)?.has(permission.id)"
            (change)="sitePermissionChange.emit({ permissionId: permission.id, siteId: item.id })"
            class="alc-margin-bottom-0">
          </mat-checkbox>
        </td>
      </tr>
    </tbody>
  </table>
</cdk-virtual-scroll-viewport>

<ng-template #noResult>
  <ng-content></ng-content>
</ng-template>
